import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

const NoItemsMessage = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <Box justifyContent="center" alignItems="center" padding="s24" flexGrow>
      <Text.Normal color="grey600" weight="medium" size="200">
        {children}
      </Text.Normal>
    </Box>
  )
}

export default observer(NoItemsMessage)
